"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var lsgPre = "lsg--";
exports.lsgPre = lsgPre;

function prefixEnumClassNames(className) {
  return className && className.replace(/lsg--/g, lsgPre);
}

exports.prefixEnumClassNames = prefixEnumClassNames;